// extracted by mini-css-extract-plugin
export default {"root":"PlasmicFinancialDetails_root__uSThw","rootselected":"PlasmicFinancialDetails_rootselected__ZG-Mt","text":"PlasmicFinancialDetails_text__KmqFV"};